module.exports={
 "/iati-activities/iati-activity/activity-date@type": [
  {
   "codelist": "ActivityDateType"
  }
 ],
 "/iati-activities/iati-activity/activity-scope@code": [
  {
   "codelist": "ActivityScope"
  }
 ],
 "/iati-activities/iati-activity/activity-status@code": [
  {
   "codelist": "ActivityStatus"
  }
 ],
 "/iati-activities/iati-activity/budget/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-activities/iati-activity/budget@status": [
  {
   "codelist": "BudgetStatus"
  }
 ],
 "/iati-activities/iati-activity/budget@type": [
  {
   "codelist": "BudgetType"
  }
 ],
 "/iati-activities/iati-activity/collaboration-type@code": [
  {
   "codelist": "CollaborationType"
  }
 ],
 "/iati-activities/iati-activity/conditions/condition@type": [
  {
   "codelist": "ConditionType"
  }
 ],
 "/iati-activities/iati-activity/contact-info@type": [
  {
   "codelist": "ContactType"
  }
 ],
 "/iati-activities/iati-activity/country-budget-items/budget-item/description@type": [
  {
   "codelist": "DescriptionType"
  }
 ],
 "/iati-activities/iati-activity/country-budget-items/budget-item@code": [
  {
   "codelist": "BudgetIdentifier",
   "condition": "../@vocabulary = '1'"
  }
 ],
 "/iati-activities/iati-activity/country-budget-items/budget-item@vocabulary": [
  {
   "codelist": "BudgetIdentifierVocabulary"
  }
 ],
 "/iati-activities/iati-activity/country-budget-items@vocabulary": [
  {
   "codelist": "BudgetIdentifierVocabulary"
  }
 ],
 "/iati-activities/iati-activity/crs-add/channel-code": [
  {
   "codelist": "CRSChannelCode"
  }
 ],
 "/iati-activities/iati-activity/crs-add/loan-status@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-activities/iati-activity/crs-add/loan-terms/repayment-plan@code": [
  {
   "codelist": "LoanRepaymentPeriod"
  }
 ],
 "/iati-activities/iati-activity/crs-add/loan-terms/repayment-type@code": [
  {
   "codelist": "LoanRepaymentType"
  }
 ],
 "/iati-activities/iati-activity/crs-add/other-flags@code": [
  {
   "codelist": "CRSAddOtherFlags"
  }
 ],
 "/iati-activities/iati-activity/default-aid-type@code": [
  {
   "codelist": "AidType",
   "condition": "@vocabulary = '1' or not(@vocabulary)"
  },
  {
   "codelist": "EarmarkingCategory",
   "condition": "@vocabulary = '2'"
  },
  {
   "codelist": "CashandVoucherModalities",
   "condition": "@vocabulary = '4'"
  }
 ],
 "/iati-activities/iati-activity/default-aid-type@vocabulary": [
  {
   "codelist": "AidTypeVocabulary"
  }
 ],
 "/iati-activities/iati-activity/default-finance-type@code": [
  {
   "codelist": "FinanceType"
  }
 ],
 "/iati-activities/iati-activity/default-flow-type@code": [
  {
   "codelist": "FlowType"
  }
 ],
 "/iati-activities/iati-activity/default-tied-status@code": [
  {
   "codelist": "TiedStatus"
  }
 ],
 "/iati-activities/iati-activity/description@type": [
  {
   "codelist": "DescriptionType"
  }
 ],
 "/iati-activities/iati-activity/document-link/category@code": [
  {
   "codelist": "DocumentCategory"
  }
 ],
 "/iati-activities/iati-activity/document-link/language@code": [
  {
   "codelist": "Language"
  }
 ],
 "/iati-activities/iati-activity/document-link@format": [
  {
   "codelist": "FileFormat"
  }
 ],
 "/iati-activities/iati-activity/fss/forecast@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-activities/iati-activity/humanitarian-scope@type": [
  {
   "codelist": "HumanitarianScopeType"
  }
 ],
 "/iati-activities/iati-activity/humanitarian-scope@vocabulary": [
  {
   "codelist": "HumanitarianScopeVocabulary"
  }
 ],
 "/iati-activities/iati-activity/location/administrative@code": [
  {
   "codelist": "Country",
   "condition": "@vocabulary = 'A4'"
  }
 ],
 "/iati-activities/iati-activity/location/administrative@vocabulary": [
  {
   "codelist": "GeographicVocabulary"
  }
 ],
 "/iati-activities/iati-activity/location/exactness@code": [
  {
   "codelist": "GeographicExactness"
  }
 ],
 "/iati-activities/iati-activity/location/feature-designation@code": [
  {
   "codelist": "LocationType"
  }
 ],
 "/iati-activities/iati-activity/location/location-class@code": [
  {
   "codelist": "GeographicLocationClass"
  }
 ],
 "/iati-activities/iati-activity/location/location-id@vocabulary": [
  {
   "codelist": "GeographicVocabulary"
  }
 ],
 "/iati-activities/iati-activity/location/location-reach@code": [
  {
   "codelist": "GeographicLocationReach"
  }
 ],
 "/iati-activities/iati-activity/other-identifier@type": [
  {
   "codelist": "OtherIdentifierType"
  }
 ],
 "/iati-activities/iati-activity/participating-org@crs-channel-code": [
  {
   "codelist": "CRSChannelCode"
  }
 ],
 "/iati-activities/iati-activity/participating-org@role": [
  {
   "codelist": "OrganisationRole"
  }
 ],
 "/iati-activities/iati-activity/participating-org@type": [
  {
   "codelist": "OrganisationType"
  }
 ],
 "/iati-activities/iati-activity/planned-disbursement/provider-org@type": [
  {
   "codelist": "OrganisationType"
  }
 ],
 "/iati-activities/iati-activity/planned-disbursement/receiver-org@type": [
  {
   "codelist": "OrganisationType"
  }
 ],
 "/iati-activities/iati-activity/planned-disbursement/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-activities/iati-activity/planned-disbursement@type": [
  {
   "codelist": "BudgetType"
  }
 ],
 "/iati-activities/iati-activity/policy-marker@code": [
  {
   "codelist": "PolicyMarker",
   "condition": "@vocabulary = '1' or not(@vocabulary)"
  }
 ],
 "/iati-activities/iati-activity/policy-marker@significance": [
  {
   "codelist": "PolicySignificance"
  }
 ],
 "/iati-activities/iati-activity/policy-marker@vocabulary": [
  {
   "codelist": "PolicyMarkerVocabulary"
  }
 ],
 "/iati-activities/iati-activity/recipient-country@code": [
  {
   "codelist": "Country"
  }
 ],
 "/iati-activities/iati-activity/recipient-region@code": [
  {
   "codelist": "Region",
   "condition": "@vocabulary = '1' or not(@vocabulary)"
  }
 ],
 "/iati-activities/iati-activity/recipient-region@vocabulary": [
  {
   "codelist": "RegionVocabulary"
  }
 ],
 "/iati-activities/iati-activity/related-activity@type": [
  {
   "codelist": "RelatedActivityType"
  }
 ],
 "/iati-activities/iati-activity/reporting-org@type": [
  {
   "codelist": "OrganisationType"
  }
 ],
 "/iati-activities/iati-activity/result/description@type": [
  {
   "codelist": "DescriptionType"
  }
 ],
 "/iati-activities/iati-activity/result/document-link/category@code": [
  {
   "codelist": "DocumentCategory"
  }
 ],
 "/iati-activities/iati-activity/result/document-link/language@code": [
  {
   "codelist": "Language"
  }
 ],
 "/iati-activities/iati-activity/result/document-link@format": [
  {
   "codelist": "FileFormat"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/baseline/document-link/category@code": [
  {
   "codelist": "DocumentCategory"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/baseline/document-link/language@code": [
  {
   "codelist": "Language"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/baseline/document-link@format": [
  {
   "codelist": "FileFormat"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/description@type": [
  {
   "codelist": "DescriptionType"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/document-link/category@code": [
  {
   "codelist": "DocumentCategory"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/document-link/language@code": [
  {
   "codelist": "Language"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/document-link@format": [
  {
   "codelist": "FileFormat"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/period/actual/document-link/category@code": [
  {
   "codelist": "DocumentCategory"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/period/actual/document-link/language@code": [
  {
   "codelist": "Language"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/period/actual/document-link@format": [
  {
   "codelist": "FileFormat"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/period/target/document-link/category@code": [
  {
   "codelist": "DocumentCategory"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/period/target/document-link/language@code": [
  {
   "codelist": "Language"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/period/target/document-link@format": [
  {
   "codelist": "FileFormat"
  }
 ],
 "/iati-activities/iati-activity/result/indicator/reference@vocabulary": [
  {
   "codelist": "IndicatorVocabulary"
  }
 ],
 "/iati-activities/iati-activity/result/indicator@measure": [
  {
   "codelist": "IndicatorMeasure"
  }
 ],
 "/iati-activities/iati-activity/result/reference@vocabulary": [
  {
   "codelist": "ResultVocabulary"
  }
 ],
 "/iati-activities/iati-activity/result@type": [
  {
   "codelist": "ResultType"
  }
 ],
 "/iati-activities/iati-activity/sector@code": [
  {
   "codelist": "Sector",
   "condition": "@vocabulary = '1' or not(@vocabulary)"
  },
  {
   "codelist": "SectorCategory",
   "condition": "@vocabulary = '2'"
  }
 ],
 "/iati-activities/iati-activity/sector@vocabulary": [
  {
   "codelist": "SectorVocabulary"
  }
 ],
 "/iati-activities/iati-activity/tag@code": [
  {
   "codelist": "UNSDG-Goals",
   "condition": "@vocabulary = '2'"
  },
  {
   "codelist": "UNSDG-Targets",
   "condition": "@vocabulary = '3'"
  }
 ],
 "/iati-activities/iati-activity/tag@vocabulary": [
  {
   "codelist": "TagVocabulary"
  }
 ],
 "/iati-activities/iati-activity/transaction/aid-type@code": [
  {
   "codelist": "AidType",
   "condition": "@vocabulary = '1' or not(@vocabulary)"
  },
  {
   "codelist": "EarmarkingCategory",
   "condition": "@vocabulary = '2'"
  },
  {
   "codelist": "CashandVoucherModalities",
   "condition": "@vocabulary = '4'"
  }
 ],
 "/iati-activities/iati-activity/transaction/aid-type@vocabulary": [
  {
   "codelist": "AidTypeVocabulary"
  }
 ],
 "/iati-activities/iati-activity/transaction/disbursement-channel@code": [
  {
   "codelist": "DisbursementChannel"
  }
 ],
 "/iati-activities/iati-activity/transaction/finance-type@code": [
  {
   "codelist": "FinanceType"
  }
 ],
 "/iati-activities/iati-activity/transaction/flow-type@code": [
  {
   "codelist": "FlowType"
  }
 ],
 "/iati-activities/iati-activity/transaction/provider-org@type": [
  {
   "codelist": "OrganisationType"
  }
 ],
 "/iati-activities/iati-activity/transaction/receiver-org@type": [
  {
   "codelist": "OrganisationType"
  }
 ],
 "/iati-activities/iati-activity/transaction/recipient-country@code": [
  {
   "codelist": "Country"
  }
 ],
 "/iati-activities/iati-activity/transaction/recipient-region@code": [
  {
   "codelist": "Region",
   "condition": "@vocabulary = '1' or not(@vocabulary)"
  }
 ],
 "/iati-activities/iati-activity/transaction/recipient-region@vocabulary": [
  {
   "codelist": "RegionVocabulary"
  }
 ],
 "/iati-activities/iati-activity/transaction/sector@code": [
  {
   "codelist": "Sector",
   "condition": "@vocabulary = '1' or not(@vocabulary)"
  },
  {
   "codelist": "SectorCategory",
   "condition": "@vocabulary = '2'"
  }
 ],
 "/iati-activities/iati-activity/transaction/sector@vocabulary": [
  {
   "codelist": "SectorVocabulary"
  }
 ],
 "/iati-activities/iati-activity/transaction/tied-status@code": [
  {
   "codelist": "TiedStatus"
  }
 ],
 "/iati-activities/iati-activity/transaction/transaction-type@code": [
  {
   "codelist": "TransactionType"
  }
 ],
 "/iati-activities/iati-activity/transaction/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-activities/iati-activity@budget-not-provided": [
  {
   "codelist": "BudgetNotProvided"
  }
 ],
 "/iati-activities/iati-activity@default-currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-activities/iati-activity@version": [
  {
   "codelist": "Version"
  }
 ],
 "/iati-activities@version": [
  {
   "codelist": "Version"
  }
 ],
 "/iati-organisations/iati-organisation/document-link/category@code": [
  {
   "codelist": "DocumentCategory"
  }
 ],
 "/iati-organisations/iati-organisation/document-link/language@code": [
  {
   "codelist": "Language"
  }
 ],
 "/iati-organisations/iati-organisation/document-link/recipient-country@code": [
  {
   "codelist": "Country"
  }
 ],
 "/iati-organisations/iati-organisation/document-link@format": [
  {
   "codelist": "FileFormat"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-country-budget/budget-line/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-country-budget/recipient-country@code": [
  {
   "codelist": "Country"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-country-budget/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-country-budget@status": [
  {
   "codelist": "BudgetStatus"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-org-budget/budget-line/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-org-budget/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-org-budget@status": [
  {
   "codelist": "BudgetStatus"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-region-budget/budget-line/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-region-budget/recipient-region@code": [
  {
   "codelist": "Region",
   "condition": "@vocabulary = '1' or not(@vocabulary)"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-region-budget/recipient-region@vocabulary": [
  {
   "codelist": "RegionVocabulary"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-region-budget/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-organisations/iati-organisation/recipient-region-budget@status": [
  {
   "codelist": "BudgetStatus"
  }
 ],
 "/iati-organisations/iati-organisation/reporting-org@type": [
  {
   "codelist": "OrganisationType"
  }
 ],
 "/iati-organisations/iati-organisation/total-budget/value@currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-organisations/iati-organisation/total-budget@status": [
  {
   "codelist": "BudgetStatus"
  }
 ],
 "/iati-organisations/iati-organisation@default-currency": [
  {
   "codelist": "Currency"
  }
 ],
 "/iati-organisations/iati-organisations@version": [
  {
   "codelist": "Version"
  }
 ],
 "@xml:lang": [
  {
   "codelist": "Language"
  }
 ]
}